import axios from 'axios';

export const getLegacyDatasetsLeaderboards = async () => {
    const response = await axios.get('/api/datasets/legacy-leaderboards');
    if(response.status === 200 || response.status === 201) {
        return Array.isArray(response.data) ? response.data : [];
    } else {
        throw new Error(response.data);
    }
}

export const sendLegacyDatasets = async (datasets) => {
    const formattedDatasets = datasets.map(dataset => ({
        id: Number(dataset.id),
        path: dataset.legacyFile
    }));

    const response = await axios.post('/api/datasets/legacy-leaderboards', formattedDatasets);
    if(response.status === 200 || response.status === 201) {
        return { data: response.data, status: response.status };
    } else {
        throw new Error(response.data);
    }
}